import { IPOMASTERBANK_DATA, IPOMASTERBANK_ERROR_DATA, IPOMASTERBANK_HIDE_ERROR_DATA, IPOMASTERBANK_START_LOADER, IPOMASTERBANK_STOP_LOADER, } from "../interface/IpoBankMaster";
import store from "@frameworks/web/redux/store";
class IpobankMasterActiton {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getIpoBankMaster(IpoMasterBank) {
        this.dispatch({
            type: IPOMASTERBANK_DATA,
            payload: { data: IpoMasterBank },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: IPOMASTERBANK_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: IPOMASTERBANK_HIDE_ERROR_DATA,
        });
    }
    startLoader() {
        this.dispatch({
            type: IPOMASTERBANK_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: IPOMASTERBANK_STOP_LOADER,
        });
    }
}
export default IpobankMasterActiton;
